/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";

/* Style imports */
import "./styles.css"
/*** End Imports ***/

const LoadingBarLg = (props) => {

    const barClasses = classNames("loading-bar", {"bar1": props.type === 1});

    return (
        <div className = {barClasses}>
        </div>
    )
};

LoadingBarLg.PropTypes = {
    type: PropTypes.number
};

export default LoadingBarLg;


// WEBPACK FOOTER //
// ./src/components/core/LoadingBarLg/LoadingBarLg.js


// WEBPACK FOOTER //
// ./src/components/core/LoadingBarLg/LoadingBarLg.js